{
  "nav": {
    "home": "Home",
    "calendar": "Kalender",
    "analytics": "Statistiken",
    "settings": "Einstellungen",
    "users": "Benutzer",
    "help": "Hilfe",
    "needsDriver": "Fahrer benötigt",
    "appointments": "Termine",
    "sentryTest": "🐛 Fehlertest"
  },
  "appointments": {
    "title": "Termine",
    "create": "Termin erstellen",
    "createTitle": "Neuen Termin erstellen",
    "createDescription": "Fügen Sie einen neuen Termin zu Ihrem Kalender hinzu",
    "editTitle": "Termin bearbeiten",
    "edit": "Bearbeiten",
    "delete": "Löschen",
    "deleteTitle": "Termin löschen?",
    "deleteConfirmation": "Möchten Sie diesen Termin wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    "deleting": "Löschen...",
    "myAppointments": "Meine",
    "othersAppointments": "Anderer",
    "pastAppointments": "Vergangene",
    "noOthersAppointments": "Keine anderen Termine",
    "noOthersAppointmentsDescription": "Keine anstehenden Termine, die anderen Familienmitgliedern zugewiesen sind.",
    "noPastAppointments": "Keine vergangenen Termine",
    "noPastAppointmentsDescription": "Es wurden noch keine Termine abgeschlossen.",
    "editDescription": "Termindetails aktualisieren",
    "assign": "Fahrer zuweisen",
    "unassign": "Zuweisung aufheben",
    "claim": "Übernehmen",
    "duration": "Dauer",
    "location": "Ort",
    "locationPlaceholder": "Ort eingeben",
    "date": "Datum",
    "time": "Zeit",
    "selectDate": "Datum auswählen",
    "selectTime": "Zeit auswählen",
    "selectDuration": "Dauer auswählen",
    "status": "Status",
    "assigned": "Zugewiesen",
    "unassigned": "Nicht zugewiesen",
    "completed": "Abgeschlossen",
    "description": "Beschreibung",
    "descriptionPlaceholder": "Zusätzliche Notizen oder Details hinzufügen",
    "descriptionOptional": "Optional - zusätzliche Notizen zum Termin",
    "titlePlaceholder": "Titel des Termins eingeben",
    "noAppointments": "Keine Termine gefunden",
    "noUnassigned": "Keine nicht zugewiesenen Termine",
    "errorLoading": "Termine konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
    "createdBy": "Erstellt von",
    "claiming": "Wird übernommen...",
    "unclaiming": "Wird aufgehoben...",
    "timeFormat": "HH:MM Format",
    "noAppointmentsScheduledForDate": "Keine Termine für dieses Datum geplant",
    "allAppointmentsAssigned": "Alle Termine sind zugewiesen",
    "noUnassignedDescription": "Alle anstehenden Termine haben zugewiesene Fahrer. Großartige Arbeit, Familie!",
    "yourAppointment": "Ihr Termin",
    "appointmentNeedDrivers": "Termine, die Fahrer benötigen",
    "noAssignedAppointmentsDescription": "Sie haben noch keine zugewiesenen Termine. Prüfen Sie nach Terminen, die Fahrer benötigen, oder erstellen Sie einen neuen.",
    "needingDrivers": "Termine benötigen Fahrer",
    "needsDriver": "Fahrer benötigt",
    "claimThisAppointment": "Diesen Termin übernehmen",
    "noUpcomingAppointments": "Keine anstehenden Termine",
    "assignTo": "Zuweisen an",
    "selectAssignee": "Person auswählen",
    "assignToDescription": "Optional - diesen Termin jemandem zuweisen"
  },
  "forms": {
    "cancel": "Abbrechen",
    "create": "Erstellen",
    "creating": "Wird erstellt...",
    "edit": "Bearbeiten",
    "update": "Aktualisieren",
    "updating": "Wird aktualisiert...",
    "delete": "Löschen",
    "title": "Titel",
    "description": "Beschreibung",
    "titleRequired": "Titel ist erforderlich",
    "titleTooLong": "Titel zu lang",
    "locationRequired": "Ort ist erforderlich",
    "locationTooLong": "Ort zu lang",
    "startTimeRequired": "Startzeit ist erforderlich",
    "durationMin": "Dauer muss mindestens 15 Minuten betragen",
    "durationMax": "Dauer kann nicht länger als 8 Stunden sein",
    "descriptionTooLong": "Beschreibung zu lang"
  },
  "users": {
    "title": "Benutzer",
    "createUser": "Benutzer hinzufügen",
    "createUserTitle": "Neuen Benutzer hinzufügen",
    "createUserDescription": "Familienmitglied hinzufügen, bevor es sich anmeldet",
    "name": "Name",
    "namePlaceholder": "Vollständigen Namen eingeben",
    "email": "E-Mail",
    "emailPlaceholder": "E-Mail-Adresse eingeben",
    "pending": "Ausstehend",
    "active": "Aktiv",
    "deleteUser": "Benutzer löschen",
    "deleteUserConfirmation": "Möchten Sie diesen Benutzer wirklich löschen? Er wird von allen Terminen abgemeldet.",
    "noUsers": "Noch keine Benutzer",
    "noUsersDescription": "Familienmitglieder hinzufügen, damit sie Terminen zugewiesen werden können, bevor sie sich anmelden.",
    "userCreated": "Benutzer hinzugefügt",
    "userCreatedDescription": "Der Benutzer wurde hinzugefügt und kann jetzt Terminen zugewiesen werden.",
    "userDeleted": "Benutzer gelöscht",
    "userDeletedDescription": "Der Benutzer wurde entfernt.",
    "createError": "Benutzer konnte nicht erstellt werden",
    "deleteError": "Benutzer konnte nicht gelöscht werden"
  },
  "analytics": {
    "title": "Statistiken",
    "driverStats": "Fahrer-Statistiken",
    "weeklyOverview": "Wochenübersicht",
    "appointmentsThisWeek": "Termine diese Woche",
    "totalAppointments": "Termine gesamt",
    "assignmentRate": "Zuweisungsrate",
    "upcomingUnassigned": "Kommende nicht zugewiesene",
    "driverStatsDescription": "Anzahl Termine pro Familienmitglied",
    "weeklyOverviewDescription": "Termine pro Woche in den letzten vier Wochen",
    "noDriverData": "Keine Fahrer-Daten verfügbar",
    "noWeeklyData": "Keine Wochendaten verfügbar",
    "weekLabel": "Woche {{number}}"
  },
  "time": {
    "hour": "Stunde",
    "hours": "Stunden",
    "minute": "Minute",
    "minutes": "Minuten"
  },
  "common": {
    "loading": "Laden...",
    "error": "Ein Fehler ist aufgetreten",
    "close": "Schließen",
    "you": "Sie",
    "thisWeek": "Diese Woche",
    "needDrivers": "Fahrer benötigt",
    "last30Days": "Letzte 30 Tage",
    "allTime": "Alle Zeit",
    "unknown": "Unbekannt",
    "driver": "Fahrer"
  },
  "calendar": {
    "title": "Kalender",
    "calendarView": "Kalenderansicht",
    "appointmentsFor": "Termine für",
    "selectedDate": "Ausgewähltes Datum",
    "noAppointments": "Keine Termine"
  },
  "auth": {
    "signIn": "Anmelden",
    "signOut": "Abmelden",
    "signInWithGoogle": "Mit Google anmelden",
    "signInDescription": "Melden Sie sich an, um auf Ihre Familienterminverwaltung zuzugreifen",
    "authorizedUsersOnly": "Nur autorisierte Familienmitglieder können auf diese Anwendung zugreifen"
  },
  "settings": {
    "title": "Einstellungen",
    "calendarSubscription": "Kalender-Abonnement",
    "calendarSubscriptionDescription": "Erhalten Sie eine persönliche Kalender-URL, die Sie zu Google Kalender, Outlook oder jeder anderen Kalenderanwendung hinzufügen können",
    "calendarUrl": "Kalender-URL",
    "calendarUrlHelp": "Kopieren Sie diese URL und fügen Sie sie als neues Abonnement zu Ihrer Kalenderanwendung hinzu",
    "regenerateUrl": "URL erneuern",
    "regenerateUrlDescription": "Erstellen Sie eine neue Kalender-URL, falls die aktuelle kompromittiert wurde",
    "regenerate": "Erneuern",
    "calendarPreferences": "Kalender-Einstellungen",
    "calendarPreferencesDescription": "Passen Sie an, wie Ihre Termine in Ihrem Kalender erscheinen",
    "appointmentScope": "Termin-Sichtbarkeit",
    "ownAppointments": "Nur meine Termine",
    "allAppointments": "Alle Familientermine",
    "showAsBusy": "Als beschäftigt anzeigen",
    "showAsBusyDescription": "Terminzeiten als beschäftigt in Ihrem Kalender markieren",
    "instructions": "Setup-Anweisungen",
    "instructionsDescription": "So fügen Sie diesen Kalender zu Ihrer bevorzugten Kalenderanwendung hinzu",
    "googleCalendar": "Google Kalender",
    "googleStep1": "Öffnen Sie Google Kalender in Ihrem Webbrowser",
    "googleStep2": "Klicken Sie auf die '+' Schaltfläche neben 'Andere Kalender'",
    "googleStep3": "Wählen Sie 'Von URL' und fügen Sie die obige Kalender-URL ein",
    "googleStep4": "Klicken Sie auf 'Kalender hinzufügen' zum Abonnieren",
    "outlookCalendar": "Microsoft Outlook",
    "outlookStep1": "Öffnen Sie Outlook und gehen Sie zum Kalender",
    "outlookStep2": "Rechtsklick auf 'Andere Kalender' und wählen Sie 'Kalender hinzufügen'",
    "outlookStep3": "Wählen Sie 'Aus dem Web abonnieren' und fügen Sie die URL ein",
    "outlookStep4": "Klicken Sie auf 'Importieren', um den Kalender hinzuzufügen",
    "urlCopied": "URL kopiert!",
    "urlCopiedDescription": "Kalender-URL wurde in die Zwischenablage kopiert",
    "copyError": "URL konnte nicht in die Zwischenablage kopiert werden",
    "tokenRegenerated": "URL erneuert!",
    "tokenRegeneratedDescription": "Eine neue Kalender-URL wurde generiert",
    "regenerateError": "Kalender-URL konnte nicht erneuert werden"
  },
  "help": {
    "title": "Hilfe & Anleitung",
    "gettingStarted": {
      "title": "Erste Schritte",
      "description": "Lernen Sie die Grundlagen der Nutzung von Termine für die Familienterminverwaltung",
      "login": {
        "title": "Wie Sie sich anmelden",
        "description": "Nur autorisierte Familienmitglieder können auf Termine zugreifen. So starten Sie:",
        "step1": "Klicken Sie auf die Schaltfläche 'Anmelden' auf der Login-Seite",
        "step2": "Wählen Sie 'Mit Google anmelden' und verwenden Sie Ihr Google-Konto",
        "step3": "Wenn Ihre E-Mail autorisiert ist, werden Sie zum Hauptdashboard weitergeleitet"
      },
      "firstSteps": {
        "title": "Ihre ersten Schritte",
        "step1": "Überprüfen Sie Ihre Spracheinstellung (wechseln Sie zwischen Deutsch/Englisch mit der Sprachschaltfläche)",
        "step2": "Besuchen Sie die Einstellungen, um Ihr persönliches Kalender-Abonnement einzurichten",
        "step3": "Erstellen Sie Ihren ersten Termin oder prüfen Sie, ob bereits andere erstellt wurden"
      }
    },
    "appointments": {
      "title": "Termine verwalten",
      "description": "Lernen Sie, wie Sie Familientermine erstellen, bearbeiten und verwalten",
      "create": {
        "title": "Einen Termin erstellen",
        "step1": "Klicken Sie auf 'Termin erstellen' von der Hauptseite oder Termine-Seite",
        "step2": "Füllen Sie die Termindetails aus: Titel, Datum, Zeit, Dauer und Ort",
        "step3": "Fügen Sie eine Beschreibung hinzu, falls nötig (optional, aber hilfreich für Familienmitglieder)",
        "step4": "Klicken Sie auf 'Erstellen', um den Termin zu speichern"
      },
      "claim": {
        "title": "Termine als Fahrer übernehmen",
        "description": "Familienmitglieder können sich freiwillig als Fahrer für Termine melden:",
        "step1": "Suchen Sie nach Terminen, die als 'Nicht zugewiesen' markiert sind - diese benötigen einen Fahrer",
        "step2": "Klicken Sie auf 'Übernehmen' bei jedem Termin, für den Sie fahren können",
        "step3": "Sobald übernommen, zeigt der Termin Ihren Namen als Fahrer an"
      },
      "statuses": {
        "title": "Terminstatus verstehen",
        "unclaimed": "Nicht zugewiesen",
        "unclaimedDesc": "Benötigt einen Fahrer",
        "claimed": "Zugewiesen",
        "claimedDesc": "Hat einen Fahrer",
        "completed": "Abgeschlossen",
        "completedDesc": "Termin beendet",
        "cancelled": "Abgebrochen",
        "cancelledDesc": "Findet nicht mehr statt"
      }
    },
    "calendar": {
      "title": "Kalender-Integration",
      "description": "Verbinden Sie Termine mit Ihren persönlichen Kalender-Apps wie Google Kalender oder Outlook",
      "setup": {
        "title": "Kalender-Abonnement einrichten",
        "step1": "Gehen Sie zu den Einstellungen und finden Sie den Abschnitt 'Kalender-Abonnement'",
        "step2": "Kopieren Sie Ihre persönliche Kalender-URL (sie ist einzigartig für Sie)",
        "step3": "Öffnen Sie Ihre bevorzugte Kalender-App (Google Kalender, Outlook, Apple Kalender, etc.)",
        "step4": "Fügen Sie die URL als neues Kalender-Abonnement entsprechend den Anweisungen Ihrer App hinzu"
      },
      "apps": {
        "title": "Unterstützte Kalender-Apps",
        "google": "Google Kalender - Von URL hinzufügen im Bereich 'Andere Kalender'",
        "outlook": "Microsoft Outlook - Aus dem Web abonnieren in den Kalendereinstellungen",
        "apple": "Apple Kalender - Abonnement-Kalender in der Kalender-App hinzufügen",
        "other": "Jede App, die ICS/iCal-Abonnement-URLs unterstützt"
      }
    },
    "settings": {
      "title": "Einstellungen & Präferenzen",
      "description": "Passen Sie an, wie Termine für Sie funktioniert",
      "language": {
        "title": "Sprache",
        "description": "Wechseln Sie zwischen Deutsch und Englisch mit der Sprachschaltfläche in der oberen Navigation"
      },
      "calendar": {
        "title": "Kalender-Einstellungen",
        "description": "Kontrollieren Sie, welche Termine in Ihrem persönlichen Kalender erscheinen:",
        "scope": "Termin-Sichtbarkeit - Wählen Sie, ob Sie nur Ihre Termine oder alle Familientermine sehen möchten",
        "busy": "Als beschäftigt anzeigen - Terminzeiten als beschäftigte Perioden in Ihrem Kalender markieren"
      }
    },
    "analytics": {
      "title": "Statistiken & Berichte",
      "description": "Familientermin-Statistiken und Aktivitäten anzeigen",
      "charts": {
        "title": "Die Diagramme verstehen",
        "appointments": "Gesamtzahl der erstellten und abgeschlossenen Termine über die Zeit",
        "completion": "Wie viele Termine jedes Familienmitglied abgeschlossen hat",
        "activity": "Aktuelle Aktivität zeigt, wer Termine erstellt, übernommen oder aktualisiert hat"
      }
    },
    "mobile": {
      "title": "Nutzung auf mobilen Geräten",
      "description": "Termine funktioniert großartig auf Handys und Tablets",
      "access": {
        "title": "Zugriff auf dem Handy",
        "step1": "Öffnen Sie Ihren mobilen Webbrowser (Safari, Chrome, etc.)",
        "step2": "Navigieren Sie zur Termine-Website-URL",
        "step3": "Fügen Sie sie zu Ihrem Startbildschirm hinzu für einfachen Zugriff (optional)"
      },
      "tips": {
        "title": "Mobile Tipps",
        "tip1": "Die Benutzeroberfläche passt sich automatisch an Ihre Bildschirmgröße an",
        "tip2": "Alle Funktionen funktionieren genauso wie auf Desktop-Computern",
        "tip3": "Sie können Termine schnell übernehmen, auch unterwegs"
      }
    },
    "troubleshooting": {
      "title": "Fehlerbehebung",
      "description": "Lösungen für häufige Probleme",
      "common": {
        "title": "Häufige Probleme",
        "login": "Ich kann mich nicht anmelden",
        "loginSolution": "Stellen Sie sicher, dass Ihre E-Mail-Adresse von einem Familienadministrator autorisiert wurde. Kontaktieren Sie ihn, wenn Sie Probleme haben.",
        "calendar": "Mein Kalender wird nicht aktualisiert",
        "calendarSolution": "Versuchen Sie, Ihre Kalender-URL in den Einstellungen zu erneuern und sie dann erneut zu Ihrer Kalender-App hinzuzufügen.",
        "mobile": "Die App funktioniert nicht auf meinem Handy",
        "mobileSolution": "Stellen Sie sicher, dass Sie einen modernen Webbrowser verwenden. Versuchen Sie, Ihren Browser-Cache zu leeren oder einen anderen Browser zu verwenden."
      }
    },
    "contact": {
      "title": "Benötigen Sie weitere Hilfe?",
      "description": "Wenn Sie immer noch Probleme haben, kontaktieren Sie Ihren Familienadministrator",
      "content": "Diese App wird von Ihrer Familie verwaltet. Wenn Sie Hilfe beim Zugang benötigen, Fragen haben oder Probleme auftreten, wenden Sie sich an die Person, die Termine für Ihre Familie eingerichtet hat."
    }
  },
  "sentryTest": {
    "title": "Sentry Fehlerüberwachung Testen",
    "warning": "Diese Seite dient zum Testen der Fehlerüberwachung. Nur in der Entwicklung verwenden.",
    "syncErrorTitle": "Synchroner Fehler",
    "syncErrorDescription": "Wirft sofort einen Fehler in der Komponente",
    "asyncErrorTitle": "Asynchroner Fehler",
    "asyncErrorDescription": "Wirft einen Fehler nach kurzer Verzögerung",
    "manualCaptureTitle": "Manuelle Erfassung",
    "manualCaptureDescription": "Erfasst eine Ausnahme manuell an Sentry",
    "triggerError": "Fehler auslösen",
    "instructions": "Wie testen",
    "step1": "Klicken Sie auf eine der Schaltflächen oben, um einen Fehler auszulösen",
    "step2": "Überprüfen Sie Ihre Browser-Konsole und den Netzwerk-Tab auf den Fehler",
    "step3": "Überprüfen Sie, ob der Fehler in Ihrem Sentry-Dashboard auf sentry.io erscheint"
  }
}
